/**
 * Pick a friendly greeting for the topbar / splash hero.
 *
 * Two axes:
 *   - time bucket (morning, afternoon, evening, late) drives the tone
 *   - locale (fr / nl / en) drives the language
 *
 * Stable per day · the picker hashes the date so the same person sees
 * the same greeting all day, then a different one tomorrow. Refresh
 * doesn't reshuffle (would feel twitchy).
 */

const POOLS = {
  fr: {
    morning:   ['Bonjour', 'Salut', 'Hello', 'Hey', 'Coucou', 'Bon matin'],
    afternoon: ['Bonjour', 'Re-bonjour', 'Salut', 'Coucou', 'Hello', 'Hey'],
    evening:   ['Bonsoir', 'Salut', 'Hello', 'Bonne soirée'],
    late:      ['Encore au boulot ?', 'Hello', 'La nuit, ça inspire'],
  },
  nl: {
    morning:   ['Goedemorgen', 'Hallo', 'Hey', 'Hoi', 'Goedendag'],
    afternoon: ['Hallo', 'Hoi', 'Goedendag', 'Hey', 'Dag'],
    evening:   ['Goedenavond', 'Hoi', 'Hey', 'Fijne avond'],
    late:      ['Nog aan het werken?', 'Hallo', 'Nachtraaf'],
  },
  en: {
    morning:   ['Good morning', 'Hey', 'Hi', 'Hello', 'Morning', 'Rise and shine'],
    afternoon: ['Hi', 'Hey', 'Hello', 'Welcome back', 'Howdy'],
    evening:   ['Good evening', 'Hey', 'Hi', 'Evening'],
    late:      ['Still going strong?', 'Hello', 'Night owl'],
  },
};

function bucketOf(hour) {
  if (hour < 5)  return 'late';
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  if (hour < 23) return 'evening';
  return 'late';
}

function dayHash(date) {
  // Small string hash · stable across refreshes on the same day.
  const s = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}-${bucketOf(date.getHours())}`;
  let h = 2166136261;  // FNV-1a
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return h;
}

export function pickGreeting(locale, date = new Date()) {
  const pool = POOLS[locale] || POOLS.en;
  const bucket = bucketOf(date.getHours());
  const options = pool[bucket] || pool.afternoon;
  return options[dayHash(date) % options.length];
}
